<template>
  <div class="box-container">
    <d-header :breadcrumbs="false" fluid>
      <h2 class="title is-5">
        <d-previous-btn
          :path="'/owners/' + $route.params.owner + '/contacts'"
        />
        {{ $t("details").capitalize() }}
      </h2>
    </d-header>

    <d-card class="mb-0" clipped>
      <d-card-row>
        <div class="columns">
          <div class="column is-one-fifth">
            <span class="has-text-weight-semibold">
              {{ $t("name").capitalize() }}
            </span>
          </div>
          <div class="column">
            {{ model.name }}
          </div>
        </div>
        <div class="columns">
          <div class="column is-one-fifth">
            <span class="has-text-weight-semibold">
              {{ $t("email").capitalize() }}
            </span>
          </div>
          <div class="column">
            {{ model.email }}
          </div>
        </div>
        <div class="columns">
          <div class="column is-one-fifth">
            <span class="has-text-weight-semibold">
              {{ $t("phone").capitalize() }}
            </span>
          </div>
          <div class="column">
            {{ model.phone }}
          </div>
        </div>
        <div class="columns">
          <div class="column is-one-fifth">
            <span class="has-text-weight-semibold">
              {{ $t("assigned_task").capitalize() }}
            </span>
          </div>
          <div class="column">
            {{ model.assigned_task }}
          </div>
        </div>
        <div class="columns">
          <div class="column is-one-fifth">
            <span class="has-text-weight-semibold">
              {{ $t("role").capitalize() }}
            </span>
          </div>
          <div class="column">
            {{ model.role }}
          </div>
        </div>
        <div class="columns">
          <div class="column is-one-fifth">
            <span class="has-text-weight-semibold">
              {{ $t("birthday").capitalize() }}
            </span>
          </div>
          <div class="column">
            {{ model.birthday }}
          </div>
        </div>

        <div class="columns">
          <div class="column is-one-fifth">
            <span class="has-text-weight-semibold">
              {{ $t("is_admin_contact").capitalize() }}
            </span>
          </div>
          <div class="column">
            <d-bool-icon
              :true-value="true"
              :false-value="false"
              :value="model.is_admin_contact"
            />
          </div>
        </div>
      </d-card-row>
    </d-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      model: {},
      loading: true,
    };
  },
  computed: {
    title() {
      if (this.model.name) {
        return this.model.name;
      }
      return "";
    },
  },
  created() {
    this.$http
      .get(
        this.$laravel.route("api.owner-contacts.show", {
          owner: this.$route.params.owner,
          owner_contact: this.$route.params.id,
        })
      )
      .then((response) => {
        this.loading = false;
        this.model = response.data.data;
      })
      .catch((e) => {
        console.error(e);
        this.$router.push("/owners");
      });
  },
};
</script>
